import { createClient } from "@supabase/supabase-js";

import { USER_METADATA_KEYS } from "../constants";

export const supabase = createClient(
  import.meta.env.VITE_SUPABASE_URL,
  import.meta.env.VITE_SUPABASE_ANON_KEY,
  {
    auth: {
      persistSession: true,
      autoRefreshToken: true,
      detectSessionInUrl: false,
    },
  }
);

export const signIn = async (email: string, password: string) => {
  try {
    const { data, error } = await supabase.auth.signInWithPassword({ email, password });
    if (error) return { user: null, session: null, error };
    return { user: data.user, session: data.session, error: null };
  } catch (error) {
    console.error("[Supabase] Unexpected error during sign in:", error);
    return { user: null, session: null, error: error as Error };
  }
};

export const signOut = async () => {
  const { error } = await supabase.auth.signOut();
  return { error };
};

export const updatePassword = async (new_password: string) => {
  const { data, error } = await supabase.auth.updateUser({
    password: new_password,
    data: { [USER_METADATA_KEYS.PASSWORD_RESET_REQUIRED]: false },
  });
  if (error) {
    console.error("[Supabase] Update Password error:", error);
    throw error;
  }
  return { user: data?.user };
};

export const generateSignedUrlForDownload = async (
  bucketName: string,
  filePath: string,
  expiresIn = 60,
  fileName?: string
): Promise<string | null> => {
  try {
    const { data, error } = await supabase.storage
      .from(bucketName)
      .createSignedUrl(filePath, expiresIn, {
        download: fileName ?? true,
      });

    if (error) {
      console.error("Supabase signed URL error:", error);
      return null;
    }

    return data?.signedUrl ?? null;
  } catch (error) {
    console.error("Error generating signed URL for download:", error);
    return null;
  }
};

export default supabase;
